/**
 * Environment Configuration
 * Automatically detects environment and uses appropriate API URLs
 */

// Environment detection
const isDevelopment = process.env.NODE_ENV === 'development'
const isProduction = process.env.NODE_ENV === 'production'
const isStaging = process.env.NODE_ENV === 'staging'

// Get environment from Vue app env or fallback to NODE_ENV
const appEnv = process.env.VUE_APP_ENV || process.env.NODE_ENV || 'development'

// Base configuration
const baseConfig = {
  app: {
    name: process.env.VUE_APP_NAME || 'AKATHRM Web',
    version: process.env.VUE_APP_VERSION || '1.0.0',
    enableDebug: process.env.VUE_APP_ENABLE_DEBUG === 'true',
  },
  api: {
    timeout: 30000,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    }
  }
}

// Environment-specific configurations
const environments = {
  development: {
    ...baseConfig,
    api: {
      ...baseConfig.api,
      baseUrl: process.env.VUE_APP_MOBILE_API_URL || 'https://hrmwebapi.akat.la:9811/api',
      timeout: 30000,
    },
    signalr: {
      url: process.env.VUE_APP_MOBILE_API_SIGNALR_URL || 'https://hrmwebapi.akat.la:9811',
      hubPath: '/chatHub'
    },
    features: {
      enableMockData: process.env.VUE_APP_ENABLE_MOCK_DATA === 'true',
      enableDebugTools: true,
      enableHotReload: true,
    }
  },
  
  production: {
    ...baseConfig,
    api: {
      ...baseConfig.api,
      baseUrl: process.env.VUE_APP_MOBILE_API_URL || 'https://hrmwebapp.akat.la:7299/api',
      timeout: 30000,
    },
    signalr: {
      url: process.env.VUE_APP_MOBILE_API_SIGNALR_URL || 'https://hrmwebapi.akat.la:9811',
      hubPath: '/chatHub'
    },
    features: {
      enableMockData: false,
      enableDebugTools: false,
      enableHotReload: false,
    }
  },
  
  staging: {
    ...baseConfig,
    api: {
      ...baseConfig.api,
      baseUrl: process.env.VUE_APP_MOBILE_API_URL || 'https://staging.akat.la:7299/api',
      timeout: 30000,
    },
    signalr: {
      url: process.env.VUE_APP_MOBILE_API_SIGNALR_URL || 'https://hrmwebapi.akat.la:9811',
      hubPath: '/chatHub'
    },
    features: {
      enableMockData: false,
      enableDebugTools: true,
      enableHotReload: false,
    }
  }
}

// Get current environment configuration
const currentConfig = environments[appEnv] || environments.development

// Export configuration
export const config = currentConfig

// Helper functions
export const getApiUrl = () => {
  return currentConfig.api.baseUrl
}

export const getWebApiUrl = () => getApiUrl()
export const getMobileApiUrl = () => getApiUrl()

// SignalR URL helpers
export const getSignalRUrl = () => currentConfig.signalr?.url || 'https://hrmwebapi.akat.la:9811'
export const getSignalRHubPath = () => currentConfig.signalr?.hubPath || '/chatHub'
export const getSignalRFullUrl = () => `${getSignalRUrl()}${getSignalRHubPath()}`

export const isDebugEnabled = () => currentConfig.app.enableDebug
export const isFeatureEnabled = (feature) => currentConfig.features[feature] || false

// Environment detection helpers
export const isDev = () => isDevelopment
export const isProd = () => isProduction
export const isStagingEnv = () => isStaging

// Log configuration on startup (only in development)
if (isDevelopment) {
  console.log('🔧 Environment Configuration:', {
    environment: appEnv,
    webApi: getWebApiUrl(),
    mobileApi: getMobileApiUrl(),
    appName: currentConfig.app.name,
    version: currentConfig.app.version,
    debugEnabled: isDebugEnabled(),
  })
}

export default config 